import type { RouteRecordRaw } from 'vue-router';

export const COMMON_CODE_ROUTER: RouteRecordRaw = {
  path: '/admin/common',
  component: () => import('@/modules/admin/commonCode/views/List.vue'),
  name: 'Common Code',
  meta: {
    title: '공통코드 관리',
    requiresAuth: true,
  },
};
